import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { THREAD_CANVAS_WIDTH } from 'src/presentation/components/pages/sidekick/threads/SidekickConstants';
import ParentItem from './ParentItem';

type ParentsPanelProps = {
  parentItemId: string;
  parents: { id: string | number; name: string }[];
  onItemClick: (threadId: string) => void;
  setIsParentsLoading: (value: boolean) => void;
};

const ParentsPanel = ({ parentItemId, parents, onItemClick, setIsParentsLoading }: ParentsPanelProps) => {
  const itemsRef = useRef<any[]>([]);

  useEffect(() => {
    setIsParentsLoading(false);
  });

  return (
    <>
      <FixedWidthContainer>
        {parents.map((parent, i) => (
          <ParentItem
            key={parent.id}
            parentItemId={parentItemId}
            thread={parent}
            ref={el => (itemsRef.current[i] = el)}
            onClick={onItemClick}
          />
        ))}
      </FixedWidthContainer>
    </>
  );
};

const FixedWidthContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  max-width: ${THREAD_CANVAS_WIDTH}px;
  width: 100%;
  flex-wrap: wrap;
  padding: 0 24px;
  z-index: 1;
`;

export default ParentsPanel;
